// extracted by mini-css-extract-plugin
module.exports = {"duration":"250ms","wrapper":"_3hZP2","enter":"_3cY1t","enterActive":"_1VKzV","exit":"uVVyS","exitActive":"_3Byk-","is-drilled":"_2Jy_H","isDrilled":"_2Jy_H"};